import React from "react";
import { Link } from "react-router-dom";

function ResultContent({ item }) {
  return (
    <div
      className="content-wrapper wow animate__animated animate__slideInUp"
      data-wow-delay={item.delay}
      data-wow-duration="2s"
    >
      <p className="box-title">{item.title}</p>
      <p className="box-content">{item.description}</p>
      {item.link && (
        <Link to={item.link}>
          {item.linkText || "Learn More"}{" "}
          <i className="fa-solid fa-arrow-right" />
        </Link>
      )}
    </div>
  );
}

function ResultImage({ item }) {
  return (
    <div className="image-wrapper">
      <img src={item.image} alt={item.title} className="img-responsive" />
    </div>
  );
}

export default function ResultsSection({ data }) {
  return (
    <section className="result-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 text-left">
            <span className="down-arrow text-left">
              <i className="fa-solid fa-arrow-down" />
            </span>
            <span className="sub-title text-left">{data.eyebrow}</span>
            <h3 className="heading">{data.title}</h3>
          </div>
          <div className="col-lg-12">
            {data.items.map((item) => (
              <div className={`result-box-wrapper ${item.theme}`} key={item.title}>
                {item.imageFirst && <ResultImage item={item} />}
                <ResultContent item={item} />
                {!item.imageFirst && <ResultImage item={item} />}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
